<template>
  <div class="agent-container">
    <div v-if="loading" class="loading">正在加载聊天窗口...</div>
    <div v-if="error" class="error">{{ error }}</div>
    <div
      v-show="!loading && !error"
      id="iframe-wrapper"
      class="iframe-wrapper"
    ></div>
  </div>
</template>

<script>
import { decodeUserId, compressAndEncode } from "@/utils/codec";

// Dify 基础配置
const BASE_URL = "https://dify.smsmart.net/chatbot/wdFIyzbwnLEsGVry";

export default {
  name: "Agent",
  data() {
    return {
      loading: true,
      error: null,
      userId: null,
    };
  },
  async mounted() {
    await this.initDifyChat();
  },
  methods: {
    async initDifyChat() {
      try {
        // 从路由参数获取编码后的 userId
        const { userId: encodedUserId } = this.$route.params;

        if (!encodedUserId) {
          this.error = "缺少用户标识参数";
          this.loading = false;
          return;
        }

        // 解码 userId
        const userId = decodeUserId(encodedUserId);

        if (!userId) {
          this.error = "无效的用户标识";
          this.loading = false;
          return;
        }

        this.userId = userId;
        // 保存到 localStorage，用于重置会话后恢复
        localStorage.setItem("dify_user_id", userId);
        console.log("解码后的用户ID:", userId);

        // 加载 Dify iframe
        await this.loadDifyIframe();

        this.loading = false;
      } catch (error) {
        console.error("初始化 Dify 聊天窗口失败:", error);
        this.error =
          "加载失败，请检查浏览器控制台 (F12)。您的浏览器可能不支持 CompressionStream API。";
        this.loading = false;
      }
    },

    async loadDifyIframe() {
      // 压缩编码 userId 用于 Dify URL
      const encodedValue = await compressAndEncode(this.userId);

      console.log("压缩编码后的用户ID:", encodedValue);

      // 构建完整的 Dify URL，添加时间戳防止缓存
      const timestamp = Date.now();

      const encodedValue2 = await compressAndEncode(this.userId+':'+timestamp);

      const finalUrl = `${BASE_URL}?app_user_id=${encodedValue}&sys.user_id=${encodedValue2}&_t=${timestamp}`;

      console.log("最终生成的 URL:", finalUrl);

      // 使用原生 JavaScript 创建 iframe
      const iframeWrapper = document.getElementById("iframe-wrapper");
      if (!iframeWrapper) {
        this.error = "找不到 iframe 容器";
        return;
      }

      // 清空容器
      iframeWrapper.innerHTML = "";

      // 创建 iframe
      const iframe = document.createElement("iframe");
      iframe.id = "dify-chat-frame";
      iframe.allow = "microphone";
      iframe.frameBorder = "0";
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.style.border = "none";
      iframe.src = "";

      // 先添加到 DOM，再设置 src（关键！）
      iframeWrapper.appendChild(iframe);

      // 最后设置 src
      iframe.src = finalUrl;
    },
  },
};
</script>

<style scoped>
.agent-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: sans-serif;
  color: #666;
  font-size: 14px;
}

.error {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: sans-serif;
  color: #ff4d4f;
  font-size: 14px;
  text-align: center;
  padding: 0 20px;
}

.iframe-wrapper {
  width: 100%;
  height: calc(100vh + 50px);
  overflow: hidden;
}

iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: none;
}
</style>
